import React, { ChangeEvent, FC } from 'react';
import { Box, Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

type MaterialPriceListsFiltersProps = {
    onFilterChange: (freetext: string) => void;
};
const MaterialPriceListsFilters: FC<MaterialPriceListsFiltersProps> = ({
    onFilterChange,
}: MaterialPriceListsFiltersProps) => {
    const { t: translate } = useTranslation(['lab-settings']);
    const handleFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
        onFilterChange(event.target.value);
    };

    return (
        <Box display="flex" alignItems="center">
            <Grid container spacing={1}>
                <Grid item sm={4} xs={12}>
                    <TextField
                        fullWidth
                        id="filter-name"
                        margin="dense"
                        name="search"
                        label={translate('lab-settings:FILTER_MATERIAL_PRICES')}
                        onChange={handleFilterChange}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default MaterialPriceListsFilters;
